<template>
  <div class="reject-agreement-statistics">
    <div class="toolbar">
      <div class="toolbar-summary">
        当前条件拒绝协议总数：{{ totalCount }}
      </div>
      <div class="toolbar-filters">
        <el-date-picker
          v-model="dateRange"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="timestamp"
          :default-time="['00:00:00', '23:59:59']"
          style="width: 360px;"
        />
        <el-input
          v-model="searchForm.page_path"
          clearable
          placeholder="拒绝所在页面路径"
          style="width: 220px; margin-left: 12px;"
        />
        <el-button type="primary" style="margin-left: 12px;" @click="handleSearch">查询</el-button>
      </div>
    </div>

    <el-tabs v-model="user_id_state" @tab-click="handleTabClick">
      <el-tab-pane
        v-for="item in tabOptions"
        :key="item.value"
        :label="item.label"
        :name="item.value"
      />
    </el-tabs>

    <el-table v-loading="loading" :data="list" stripe :height="wheight - 320">
      <el-table-column prop="id" label="ID" width="100" />
      <el-table-column label="是否协议更新拒绝" min-width="160">
        <template slot-scope="scope">
          {{ formatIsAgreementUpdate(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column prop="page_path" label="拒绝所在页面路径" min-width="220" show-overflow-tooltip />
      <el-table-column prop="refused_at_format" label="拒绝时间" min-width="180" />
    </el-table>

    <el-pagination
      class="content-center content-top-padded"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :current-page="params.page"
      :page-size="params.page_size"
      :page-sizes="[10, 20, 50]"
      :total="totalCount"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getAgreementRefuseLogList } from './api'

const tabOptions = [
  { label: '全部', value: 'all' },
  { label: '游客拒绝', value: 'anonymous' },
  { label: '协议更新拒绝', value: 'logged_in' }
]

export default {
  name: 'RejectAgreementStatistics',
  data () {
    return {
      loading: false,
      user_id_state: 'all',
      tabOptions,
      dateRange: [],
      searchForm: {
        page_path: ''
      },
      appliedFilters: {
        page_path: '',
        dateRange: []
      },
      list: [],
      totalCount: 0,
      params: {
        page: 1,
        page_size: 10
      }
    }
  },
  computed: {
    ...mapGetters(['wheight'])
  },
  mounted () {
    this.getList()
  },
  methods: {
    handleSearch () {
      this.appliedFilters = {
        page_path: this.searchForm.page_path.trim(),
        dateRange: this.dateRange ? [...this.dateRange] : []
      }
      this.params.page = 1
      this.getList()
    },
    handleTabClick () {
      this.params.page = 1
      this.getList()
    },
    handleCurrentChange (page) {
      this.params.page = page
      this.getList()
    },
    handleSizeChange (pageSize) {
      this.params.page = 1
      this.params.page_size = pageSize
      this.getList()
    },
    buildParams () {
      const [startTime, endTime] = this.appliedFilters.dateRange || []

      return {
        page: this.params.page,
        pageSize: String(this.params.page_size),
        user_id_state: this.user_id_state,
        page_path: this.appliedFilters.page_path || '',
        source: '',
        platform: '',
        start_time: startTime ? Math.floor(startTime / 1000) : '',
        end_time: endTime ? Math.floor(endTime / 1000) : ''
      }
    },
    getList () {
      this.loading = true
      getAgreementRefuseLogList(this.buildParams()).then(res => {
        const data = (res.data && res.data.data) ? res.data.data : {}
        this.list = data.list || []
        this.totalCount = Number(data.total_count || 0)
      }).catch(() => {
        this.$message.error('获取拒绝协议统计失败')
      }).finally(() => {
        this.loading = false
      })
    },
    formatIsAgreementUpdate (row) {
      return row.user_id != 0 ? '是' : '否'
    }
  }
}
</script>

<style scoped lang="scss">
.reject-agreement-statistics {
  .toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
    flex-wrap: wrap;
    gap: 12px;
  }

  .toolbar-summary {
    font-size: 14px;
    color: #303133;
  }

  .toolbar-filters {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
}
</style>
